import { Engine, Scene, ArcRotateCamera, Vector3, HemisphericLight, Mesh, MeshBuilder,
     ActionManager, ExecuteCodeAction, Color3, Color4, Material, StandardMaterial, Axis, TransformNode, AxesViewer} from "@babylonjs/core";

import {Track, StraightTrack, RightAngleTrack, RotatableStraightTrack} from "./track"
import {World} from "./world"

class Tile {
    plane: Mesh;
    track?: Track;
    x: number;
    y: number;
    world: World;

    constructor(scene, x, y, world) {
        let height = 1;
        let width = 1;

        this.x = x;
        this.y = y;

        this.world = world;

        let tileColor = new Color3(0.6, 0.46, 0.3);

        let tileMat: StandardMaterial = new StandardMaterial('tile', scene);
        tileMat.diffuseColor = tileColor;

        // const parentMesh = new TransformNode("parent", scene);

        this.plane = MeshBuilder.CreatePlane("plane", {height: height, width: width, sideOrientation: Mesh.DOUBLESIDE}, scene);
        
        // const axes = new AxesViewer(scene, 1);
        // axes.xAxis.parent = this.plane
        // axes.yAxis.parent = this.plane
        // axes.zAxis.parent = this.plane

        this.plane.position.x = x;
        this.plane.position.y = 0;
        this.plane.position.z = y;
        
        this.plane.material = tileMat;

        this.plane.rotate(Axis.X, 3*Math.PI/2);

        // this.plane.setParent(parentMesh);

        // Lines to frame the tile
        const lineOptions = {
            points: [
                new Vector3(-width/2, -height/2, 0),
                new Vector3(width/2, -height/2, 0),
                new Vector3(width/2, height/2, 0),
                new Vector3(-width/2, height/2, 0),

            ],
            updatable: false,
            colors: [
                new Color4(0, 0, 0, 1),
                new Color4(0, 0, 0, 1),
                new Color4(0, 0, 0, 1),
                new Color4(0, 0, 0, 1),
            ]
          };
        let linesMesh = MeshBuilder.CreateLines("lines", lineOptions, scene);
        linesMesh.parent = this.plane;

        this.plane.actionManager = new ActionManager(scene);

        // Highlight on hover
        let highlightedMaterial: StandardMaterial = new StandardMaterial('green', scene);
        highlightedMaterial.diffuseColor
        highlightedMaterial.emissiveColor = new Color3(0.8, 0.8, 0);

        this.plane.actionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, (evt) => {
                this.plane.material = highlightedMaterial;
            })
        );
    
        // Unhighlight on hover off
        this.plane.actionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnPointerOutTrigger, (evt) => {
                this.plane.material = tileMat;
            })
        );

        // On click place track
        this.plane.actionManager.registerAction(
            new ExecuteCodeAction(ActionManager.OnLeftPickTrigger, (evt) => {
                if(world.trackType === "curved") {
                    let track: Track = new RightAngleTrack(scene, x, y, this, this.world);
                    this.track = track;
                } else if(world.trackType === "straight") {
                    let track: Track = new StraightTrack(scene, x, y, this, this.world);
                    this.track = track;
                } else if(world.trackType === "rotatable straight") {
                    let track: Track = new RotatableStraightTrack(scene, x, y, this, this.world);
                    this.track = track;
                }
            })
        );
    }
}

export {Tile};